import React from 'react';
import { Helmet } from 'react-helmet-async';
import { Link } from 'react-router-dom';
import { ScrollText } from 'lucide-react';

const AGBPage: React.FC = () => {
  return (
    <div className="pt-24 pb-16">
      <Helmet>
        <title>AGB - Allgemeine Geschäftsbedingungen | Easy Vertrag</title>
        <meta name="description" content="Allgemeine Geschäftsbedingungen von Easy Vertrag. Informieren Sie sich über unsere Nutzungsbedingungen, Lieferkonditionen und Affiliate-Marketing-Hinweise." />
        <meta name="robots" content="noindex, follow" />
        <link rel="canonical" href="https://easy4vertrag.de/agb" />
      </Helmet>
      <div className="container mx-auto px-4">
        <div className="max-w-4xl mx-auto">
          <div className="mb-12 flex items-center justify-center">
            <div className="w-16 h-16 bg-blue-100 rounded-full flex items-center justify-center">
              <ScrollText className="w-8 h-8 text-blue-600" />
            </div>
          </div>

          <h1 className="text-3xl font-bold text-center mb-8">Allgemeine Geschäftsbedingungen</h1>
          
          <div className="bg-white rounded-lg shadow-md p-8">
            <p className="text-gray-600 mb-6">
              Stand: 01.01.2025
            </p>

            <section className="mb-8">
              <h2 className="text-2xl font-bold text-gray-800 mb-4">1. Geltungsbereich</h2>
              <p className="text-gray-700 mb-4">
                Diese Allgemeinen Geschäftsbedingungen (nachfolgend "AGB") gelten für alle Geschäftsbeziehungen zwischen Easy Vertrag, Bismarck Straße 31, 66333 Völklingen (nachfolgend "wir" oder "uns") und unseren Kunden (nachfolgend "Kunde"). Die AGB gelten nur, wenn der Kunde Verbraucher im Sinne des § 13 BGB ist.
              </p>
            </section>

            <section className="mb-8">
              <h2 className="text-2xl font-bold text-gray-800 mb-4">2. Vertragspartner</h2>
              <p className="text-gray-700 mb-4">
                Der Kaufvertrag kommt zustande mit Easy Vertrag<br />
                Bismarck Straße 31<br />
                66333 Völklingen<br />
                Vertreten durch: Einzelunternehmer<br />
                Kontakt: easy90az@gmail.com
              </p>
            </section>

            <section className="mb-8">
              <h2 className="text-2xl font-bold text-gray-800 mb-4">3. Affiliate Marketing</h2>
              <p className="text-gray-700 mb-4">
                Wir weisen darauf hin, dass wir als Affiliate-Partner verschiedener Telekommunikationsunternehmen tätig sind. Bei Abschluss eines Vertrages über unsere Affiliate-Links erhalten wir eine Provision vom jeweiligen Anbieter. Für den Kunden entstehen dadurch keine zusätzlichen Kosten.
              </p>
            </section>

            <section className="mb-8">
              <h2 className="text-2xl font-bold text-gray-800 mb-4">4. Vertragsschluss</h2>
              <p className="text-gray-700 mb-4">
                Die Präsentation unserer Produkte stellt kein bindendes Angebot dar. Erst die Bestellung eines Produkts durch den Kunden ist ein bindendes Angebot nach § 145 BGB. Im Falle der Annahme dieses Angebotes versenden wir an den Kunden eine Auftragsbestätigung per E-Mail.
              </p>
            </section>

            <section className="mb-8">
              <h2 className="text-2xl font-bold text-gray-800 mb-4">5. Widerrufsrecht</h2>
              <p className="text-gray-700 mb-4">
                Verbrauchern steht grundsätzlich ein Widerrufsrecht zu. Nähere Informationen zum Widerrufsrecht ergeben sich aus unserer Widerrufsbelehrung.
              </p>
            </section>

            <section className="mb-8">
              <h2 className="text-2xl font-bold text-gray-800 mb-4">6. Preise und Versandkosten</h2>
              <p className="text-gray-700 mb-4">
                Alle Preise verstehen sich einschließlich der jeweils gültigen gesetzlichen Mehrwertsteuer. Zusätzlich fallen Versandkosten an, die vor Abgabe der Bestellung im Warenkorb angezeigt werden.
              </p>
            </section>

            <section className="mb-8">
              <h2 className="text-2xl font-bold text-gray-800 mb-4">7. Zahlung</h2>
              <p className="text-gray-700 mb-4">
                Die Zahlung erfolgt wahlweise per Vorkasse, Kreditkarte, PayPal oder Sofortüberweisung. Wir behalten uns vor, einzelne Zahlungsarten auszuschließen.
              </p>
            </section>

            <section className="mb-8">
              <h2 className="text-2xl font-bold text-gray-800 mb-4">8. Gewährleistung</h2>
              <p className="text-gray-700 mb-4">
                Es gelten die gesetzlichen Gewährleistungsrechte. Ansprüche auf Schadensersatz unterliegen den Einschränkungen gemäß Ziffer 9 (Haftungsbeschränkung).
              </p>
            </section>

            <section className="mb-8">
              <h2 className="text-2xl font-bold text-gray-800 mb-4">9. Haftungsbeschränkung</h2>
              <p className="text-gray-700 mb-4">
                Wir haften unbeschränkt für Vorsatz und grobe Fahrlässigkeit sowie nach Maßgabe des Produkthaftungsgesetzes. Für leichte Fahrlässigkeit haften wir bei Schäden aus der Verletzung des Lebens, des Körpers und der Gesundheit von Personen.
              </p>
            </section>

            <section>
              <h2 className="text-2xl font-bold text-gray-800 mb-4">10. Schlussbestimmungen</h2>
              <p className="text-gray-700 mb-4">
                Es gilt deutsches Recht unter Ausschluss des UN-Kaufrechts. Die Vertragssprache ist deutsch. Erfüllungsort für alle Leistungen aus den mit uns bestehenden Geschäftsbeziehungen sowie Gerichtsstand ist unser Sitz, soweit Sie nicht Verbraucher, sondern Kaufmann, juristische Person des öffentlichen Rechts oder öffentlich-rechtliches Sondervermögen sind.
              </p>
            </section>
          </div>

          <div className="mt-12 text-center">
            <Link 
              to="/kontakt" 
              className="inline-flex items-center justify-center px-6 py-3 bg-blue-600 text-white font-medium rounded-lg hover:bg-blue-700 transition-colors duration-300"
            >
              Bei Fragen kontaktieren Sie uns
            </Link>
          </div>
        </div>
      </div>
    </div>
  );
};

export default AGBPage;